module.exports = __webpack_public_path__ + "static/media/fix_hublot.c5bb94be.png";